import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export type BizChatAppState = "loading" | "loaded" | "cached" | "removed";

export interface OnBizChatAppStateChangedMessage {
    event: BizChatAppState;
    mailboxInfo: MailboxInfo;
    targetWindow: Window;
    sessionId: string | undefined;
}

export const onBizChatAppStateChanged: (event: BizChatAppState, mailboxInfo: MailboxInfo, targetWindow: Window, sessionId: string | undefined) => OnBizChatAppStateChangedMessage = action("onBizChatAppStateChanged", (event: BizChatAppState, mailboxInfo: MailboxInfo, targetWindow: Window, sessionId: string | undefined): OnBizChatAppStateChangedMessage => ({
    event,
    mailboxInfo,
    targetWindow,
    sessionId,
}));
